const black = '#4B4B4B';
const white = '#FFFFFF';
const blue = '#4EB3DC';
const yellow = '#FDDC2E';
const darkyellow = '#FCC927';
const green = '#7ED321';
const milkybrown = '#C7B7A8';
const darkbrown = '#84776a';
const lightorange = '#F77A47';
const lightgrey = '#A6A6A6';
const red = 'red';
export default {
    black,
    white,
    red,
    blue,
    yellow,
    darkyellow,
    green,
    lightgrey,
    milkybrown,
    darkbrown,
    lightorange,
    roundedInputBorder: milkybrown,
    fadedText: lightgrey,
    darkText: black,
    error: lightorange,
    borderColor: milkybrown,
    blueLink: blue,
    blackLink: black,
    available: green,
    occupied: milkybrown,
    icon: darkbrown,
    like: green,
    disabledPrimaryButtonBackground: '#F3F3F3',
};
